<div class="marker-pin">
    <div class="marker-pin__circle" [style.background]="color"></div>
</div>
